import SEO from '../components/SEO';

export default function PrivacyPolicyPage() {
    return (
        <div className="min-h-screen bg-white">
            <SEO title="Privacy Policy" description="NSO India Privacy Policy" noIndex={true} />
            <section className="bg-secondary py-16 md:py-24">
                <div className="max-w-4xl mx-auto px-4 text-center">
                    <h1 className="font-heading text-4xl md:text-5xl text-white mb-6">Privacy Policy</h1>
                    <p className="text-white/70 font-body text-lg">Last updated: March 6, 2026</p>
                </div>
            </section>
            <section className="py-16 md:py-24">
                <div className="max-w-4xl mx-auto px-4 font-body text-gray-700 space-y-8 leading-relaxed">
                    <div>
                        <h2 className="text-2xl font-heading text-secondary mb-4">1. Introduction</h2>
                        <p>Welcome to Nso-India, operated by NSO SERVICES PRIVATE LIMITED ("we", "us", or "our"). We respect your privacy and are committed to protecting your personal data. This Privacy Policy will inform you about how we handle your personal data, your privacy rights, and how the law protects you when you use our platform.</p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-heading text-secondary mb-4">2. The Data We Collect About You</h2>
                        <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
                        <ul className="list-disc pl-6 mt-4 space-y-2">
                            <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
                            <li><strong>Contact Data</strong> includes billing address, delivery address, email address, and telephone numbers.</li>
                            <li><strong>Financial Data</strong> includes bank account and payment card details (processed securely via our payment gateways).</li>
                            <li><strong>Transaction Data</strong> includes details about payments to and from you and other details of products you have purchased from us.</li>
                            <li><strong>Technical Data</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, and other technology on the devices you use to access this website.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-2xl font-heading text-secondary mb-4">3. How We Use Your Personal Data</h2>
                        <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
                        <ul className="list-disc pl-6 mt-4 space-y-2">
                            <li>Where we need to perform the contract we are about to enter into or have entered into with you (e.g., fulfilling an order).</li>
                            <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
                            <li>Where we need to comply with a legal obligation.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-2xl font-heading text-secondary mb-4">4. Data Security</h2>
                        <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered, or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know.</p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-heading text-secondary mb-4">5. Your Legal Rights</h2>
                        <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, to portability of data, and (where the lawful ground of processing is consent) to withdraw consent.</p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-heading text-secondary mb-4">6. Contact Details</h2>
                        <p>If you have any questions about this Privacy Policy or our privacy practices, please contact us at:</p>
                        <div className="mt-4 p-6 bg-gray-50 rounded-2xl border border-gray-100">
                            <p><strong>NSO SERVICES PRIVATE LIMITED</strong></p>
                            <p>NSO Superstore, Sumitra Heights,</p>
                            <p>Opp-New Court, Kachery Road, Uditnagar,</p>
                            <p>Rourkela-769012, Odisha, INDIA</p>
                            <p>Email: support@Nso-India.com</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
